import { Component, input, InputSignal, output } from '@angular/core';

import { TranscriptEntryLoadingStateComponent } from './loading-state/transcript-entry-loading-state.component';
import { TranscriptEntryComponent } from './transcript-entry/transcript-entry.component';
import { Content, Transcript } from './types';

@Component({
  selector: 'glxy-transcript',
  standalone: true,
  imports: [TranscriptEntryLoadingStateComponent, TranscriptEntryComponent],
  templateUrl: './transcript.component.html',
  styleUrls: ['./transcript.component.scss'],
})
export class TranscriptComponent {
  transcript: InputSignal<Transcript | undefined> = input<Transcript>();
  readonly contentClicked = output<Content>();

  clickedContent($event: Content): void {
    this.contentClicked.emit($event);
  }
}
